import React from "react";
import { Pill } from "components/common";
import {
  BOOST_PRODUCT_STATUSES,
  STRIPE_SUBSCRIPTION_STATUSES,
} from "components/Pages/Boost/consts";
import { tierColors, termColors } from "./helpers";

const productStatusColors = {
  [BOOST_PRODUCT_STATUSES.ENROLLED]: "bg-green-500",
  [BOOST_PRODUCT_STATUSES.TERMINATED]: "bg-red-500",
  unsupported: "bg-gray-500",
};

const subscriptionStatusColors = {
  [STRIPE_SUBSCRIPTION_STATUSES.ACTIVE]: "bg-green-500",
  [STRIPE_SUBSCRIPTION_STATUSES.PAST_DUE]: "bg-yellow-500",
  [STRIPE_SUBSCRIPTION_STATUSES.CANCELED]: "bg-red-500",
  unsupported: "bg-gray-500",
};

/**
 * @param {Object} props
 * @param {String} props.productStatus
 * @param {number} props.scheduledTierUpdate.productTerm
 * @param {String} props.scheduledTierUpdate.productTier
 * @param {Date} props.scheduledCancellationDate
 * @param {Date} props.scheduledResumeDate
 * @param {Object} props.scheduledUpdate
 */
const BoostSubscriptionStatus = (props) => {
  const {
    productStatus,
    productTerm,
    productTier,
    scheduledCancellationDate,
    scheduledResumeDate,
    scheduledUpdate,
    subscription,
  } = props;

  const nextTerm = scheduledUpdate?.term;
  const nextTier = scheduledUpdate?.tier;
  const subscriptionStatus = subscription?.status || "unknown";

  const isPaymentPaused = !!scheduledResumeDate;
  const isMarkedForCancellation = !!scheduledCancellationDate;
  const isChangeScheduled = !!scheduledUpdate?.startDate;

  const productStatusColor =
    productStatusColors[productStatus] || productStatusColors.unsupported;
  const subscriptionStatusColor =
    subscriptionStatusColors[subscriptionStatus] ||
    subscriptionStatusColors.unsupported;

  return (
    <>
      <div className="flex">
        <div className="flex">
          <Pill
            label={productStatus}
            pillColor={productStatusColor}
            className="mr-0 rounded-l-full border-r"
          />
          <Pill
            label={subscriptionStatus}
            pillColor={subscriptionStatusColor}
            className="rounded-r-full"
          />
        </div>
        <span className="mx-2">|</span>
        <div className="flex">
          <Pill
            label={productTier}
            pillColor={tierColors[productTier]}
            className="mr-0 rounded-l-full"
          />
          <Pill
            label={productTerm}
            pillColor={termColors[productTerm]}
            className="rounded-r-full"
          />
          {!!nextTier && !!nextTerm && (
            <>
              <i className="self-center mx-2 fa-solid fa-arrow-right-long" />
              <Pill
                label={nextTier}
                pillColor={tierColors[nextTier]}
                className="mr-0 rounded-l-full"
              />
              <Pill
                label={nextTerm}
                pillColor={termColors[nextTerm]}
                className="rounded-r-full"
              />
            </>
          )}
        </div>
      </div>
      <div className="flex mt-2 space-x-1">
        {isPaymentPaused && (
          <Pill label="payments paused" pillColor="bg-blue-400" />
        )}
        {isMarkedForCancellation && (
          <Pill label="set to cancel" pillColor="bg-red-500" />
        )}
        {isChangeScheduled && (
          <Pill label="downgrade scheduled" pillColor="bg-green-500" />
        )}
      </div>
    </>
  );
};

export default BoostSubscriptionStatus;
